import { getApi, postApi } from "../helpers/auth_helpers";
import type { MediaApi, InitMedia, OriginalDownload } from "./mediaTypes";

const base = () => String(process.env.REACT_APP_SERVERURL || "").replace(/\/+$/, "") + "/media";
function payload<T>(response: any): T {
  if (!response?.success || response.data == null) throw new Error(response?.message || "Media service unavailable");
  return response.data as T;
}
const post = async <T>(path: string, input: unknown = {}) => payload<T>(await postApi(base() + path, input));
export const mediaApi: MediaApi = {
  init: (input: InitMedia) => post("/init", input),
  masterUpload: id => post("/" + encodeURIComponent(id) + "/master/upload"),
  completeMaster: id => post("/" + encodeURIComponent(id) + "/master/complete"),
  startOriginal: id => post("/" + encodeURIComponent(id) + "/original/multipart/start"),
  presignPart: (id, partNumber) => post("/" + encodeURIComponent(id) + "/original/multipart/parts", { partNumber }),
  completeOriginal: id => post("/" + encodeURIComponent(id) + "/original/multipart/complete"),
  downloadOriginal: id => post<OriginalDownload>("/" + encodeURIComponent(id) + "/original/download"),
  get: async id => payload(await getApi(base() + "/" + encodeURIComponent(id))),
};
export const isMediaOptimizationEnabled = () => process.env.REACT_APP_MEDIA_OPTIMIZATION_V1_ENABLED === "true";
